import { useCallback, useEffect, useState } from 'react';
import GooglePayButton from '@google-pay/button-react';

import { doRequest } from '@r1-frontend/do-request';
import { getMerchantInfo, IGetMerchantInfoResponseDto } from '@r1-frontend/api-domru/api-profile/v1/pay-list/acquiring-seamless-pay-gw-list';

import { IS_PRODUCTION_ENVIROMENT } from '~/src/constants';

import * as ST from './styled';

export const TYPE_GOOGLE_TOKEN = '1';

const MERCHANT_ID = '01297674766164485968'; // Боевой ID от гугла

const getDataRequest = (paySumm: string, info: IGetMerchantInfoResponseDto): google.payments.api.PaymentDataRequest => ({
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
        {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                allowedCardNetworks: ['MASTERCARD', 'VISA'],
            },
            tokenizationSpecification: {
                type: 'PAYMENT_GATEWAY',
                parameters: {
                    gateway: info.gateway,
                    gatewayMerchantId: IS_PRODUCTION_ENVIROMENT ? info.gatewayMerchantId : 'domru',
                },
            },
        },
    ],
    merchantInfo: {
        merchantId: MERCHANT_ID,
        merchantName: 'dom.ru',
    },
    transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPriceLabel: 'Total',
        totalPrice: paySumm || '0',
        currencyCode: 'RUB',
        countryCode: 'RU',
    },
});

export interface IGBtnProps {
    paySumm: number,
    onPaymentCreate: (payToken: string, type: typeof TYPE_GOOGLE_TOKEN) => void,
}

export const GooglePayBtn = ({
    paySumm,
    onPaymentCreate,
}: IGBtnProps): JSX.Element => {
    const [paymentDataRequest, setPaymentDataRequest] = useState<google.payments.api.PaymentDataRequest | null>(null);
    const [merchantInfo, setMerchantInfo] = useState<IGetMerchantInfoResponseDto | null>(null);

    const initialazeClient = useCallback(async() => {
        if (!merchantInfo) {
            /* Получаем информацию по мерчанту */
            const resp = await doRequest.apiProfile<IGetMerchantInfoResponseDto>(getMerchantInfo());

            if (!resp.isSuccess) {
                return;
            }

            setMerchantInfo(resp.payload);
        }
    }, [merchantInfo]);

    useEffect(() => {
        initialazeClient();
    }, [initialazeClient]);

    useEffect(() => {
        if (merchantInfo) {
            /* Заполняем первоначальные настройки */
            const paymentData = getDataRequest(`${paySumm}`, merchantInfo);

            setPaymentDataRequest(paymentData);
        }
    }, [paySumm, merchantInfo]);

    const onPayClick = useCallback((ev) => {
        if (!paySumm) {
            ev.preventDefault();
        }
    }, [paySumm]);

    const onLoadPaymentData = useCallback((paymentData) => {
        const payToken = paymentData?.paymentMethodData?.tokenizationData?.token;
        onPaymentCreate(payToken || '', TYPE_GOOGLE_TOKEN);
    }, [onPaymentCreate]);

    return (
        <>
        {merchantInfo && paymentDataRequest &&
            <ST.GoogleBtnWrapper>
                <GooglePayButton
                    environment={IS_PRODUCTION_ENVIROMENT ? 'PRODUCTION' : 'TEST'}
                    buttonSizeMode='fill'
                    buttonType='buy'
                    paymentRequest={paymentDataRequest}
                    onLoadPaymentData = {onLoadPaymentData}
                    onClick={onPayClick}
                    buttonLocale='ru-RU'
                />
            </ST.GoogleBtnWrapper>
        }
        </>
    );
};
